var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"align-center my-md-10 my-4 flex d-flex block ml-md-16 pl-md-16"},[_c('v-icon',{staticClass:"gradiente-yellow-1 mx-md-6",attrs:{"size":"80"}},[_vm._v("mdi-bee ")]),_c('h1',{staticClass:"block gradiente-yellow-1 mt-4",staticStyle:{"font-size":"36pt"}},[_vm._v(" "+_vm._s(_vm.$t('skills.title'))+" ")])],1),_c('v-row',{staticClass:"d-flex",staticStyle:{"overflow":"auto"}},[_c('v-col',{staticClass:"d-flex flex-wrap px-4",class:_vm.$vuetify.breakpoint.width > 650 ? 'mx-16' : 'mx-auto',style:(_vm.$vuetify.breakpoint.width > 650
          ? 'min-width: 1125px; max-width: 1125px'
          : 'min-width: 375px; max-width: 375px;'),attrs:{"cols":"12","md":"4"}},_vm._l((_vm.skillsWithDescriptions),function(skill,i){return _c('div',{key:i,class:_vm.$vuetify.breakpoint.width > 650
            ? i === 6 || i === 18 || i === 30 || i === 42
              ? 'ml-7 mt-n4'
              : ''
            : i === 2 ||
              i === 5 ||
              i === 8 ||
              i === 11 ||
              i === 14 ||
              i === 17 ||
              i === 20 ||
              i === 23 ||
              i === 26 ||
              i === 29 ||
              i === 32 ||
              i === 35 ||
              i === 38 ||
              i === 41 ||
              i === 44 ||
              i === 47
            ? 'ml-7'
            : ''},[_c('div',{staticClass:"hexagon ma-2 glass-fx d-flex align-center justify-center",class:_vm.$vuetify.breakpoint.width > 650
              ? i === 6 || i === 18 || i === 30 || i === 42
                ? 'ml-16 mt-n4'
                : '' || i > 5
                ? 'mt-n8'
                : ''
              : i === 2 ||
                i === 5 ||
                i === 8 ||
                i === 11 ||
                i === 14 ||
                i === 17 ||
                i === 20 ||
                i === 23 ||
                i === 26 ||
                i === 29 ||
                i === 32 ||
                i === 35 ||
                i === 38 ||
                i === 41 ||
                i === 44 ||
                i === 47
              ? 'mx-16 my-n8'
              : '',on:{"click":function($event){return _vm.selectSkill(i)}}},[_c('div',{},[_c('v-img',{staticClass:"shadow-2",attrs:{"max-width":"80px","src":skill.img}})],1)])])}),0),_c('v-col',{staticClass:"align-center d-flex justify-center ml-n8",attrs:{"cols":"12","md":"3"}},[(_vm.$vuetify.breakpoint.width > 1800)?_c('ModalSelectSkill',{attrs:{"selectSkillCard":_vm.selectSkillCard},on:{"close":function($event){_vm.dialog = false},"selectNextSkill":_vm.selectNextSkill,"selectPrevSkill":_vm.selectPrevSkill}}):_c('v-dialog',{attrs:{"max-width":"500","min-width":"300"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('ModalSelectSkill',{attrs:{"selectSkillCard":_vm.selectSkillCard},on:{"close":function($event){_vm.dialog = false},"selectNextSkill":_vm.selectNextSkill,"selectPrevSkill":_vm.selectPrevSkill}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }